// src/api/reportApi.js
import axiosInstance from "./axiosConfig";

export const uploadReport = (formData) => {
  return axiosInstance.post("/reports", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
